import { ReportEmergencyCallButton } from '../ReportEmergencyCallButton'
import {
  trackButtonPressed,
  type ScreenInteractionContext,
} from '../platform/analytics/interactionAnalytics'

type Button = { requestType: string; label: string }

type Props = {
  emergencyNumber?: string
  buttons: Button[]
  onSelectRequest: (requestType: string) => void
  analytics?: ScreenInteractionContext
}

export function MakeARequestPanel({
  emergencyNumber,
  buttons,
  onSelectRequest,
  analytics,
}: Props) {
  const hasNonEmergency = buttons.length > 0

  return (
    <section className="make-a-request-panel">
      {emergencyNumber ? (
        <div className="make-a-request-emergency">
          <h3 className="make-a-request-section-title">Emergency Contact</h3>
          <p className="make-a-request-intro">
            In an <strong>emergency</strong> contact:
          </p>
          <ReportEmergencyCallButton phone={emergencyNumber} variant="standard" analytics={analytics} />
        </div>
      ) : null}
      {hasNonEmergency ? (
        <>
          <h3 className="make-a-request-section-title">Non-Emergency Requests</h3>
          <p className="make-a-request-intro">
            For <strong>non-emergency</strong> communications or requests:
          </p>
          <div className="app-link-btn-list">
            {buttons.map((btn) => (
              <button
                key={btn.requestType}
                type="button"
                className="app-link-btn"
                onClick={() => {
                  if (analytics) {
                    trackButtonPressed({
                      ...analytics,
                      button: btn.label,
                      request_type: btn.requestType,
                    })
                  }
                  onSelectRequest(btn.requestType)
                }}
              >
                {btn.label}
              </button>
            ))}
          </div>
        </>
      ) : null}
    </section>
  )
}
